import React from 'react';

const ButtSizeStep = ({ data, updateData, onNext }) => {
  const sizes = [
    { id: 'small', label: 'Small', image: 'https://assets.fnlfx.com/01JV2AFRDN86SHKPG3N60E96G6/sT2KAwqx.webp' },
    { id: 'medium', label: 'Medium', image: 'https://assets.fnlfx.com/01JV2AFRDN86SHKPG3N60E96G6/BOSxqPm8.webp' },
    { id: 'large', label: 'Large', image: 'https://assets.fnlfx.com/01JV2AFRDN86SHKPG3N60E96G6/jtknFICJ.webp' },
    { id: 'huge', label: 'Huge', image: 'https://assets.fnlfx.com/01JV2AFRDN86SHKPG3N60E96G6/iMfZQ9by.webp' }
  ];

  const handleSelect = (sizeId) => {
    updateData('buttSize', sizeId);
    setTimeout(() => onNext(), 300);
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        When she turns back to you what would you prefer to see?
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        Select the most exciting option now
      </p>

      <div className="grid grid-cols-2 gap-4">
        {sizes.map((size) => (
          <button
            key={size.id}
            onClick={() => handleSelect(size.id)}
            className={`group relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-105 ${
              data.buttSize === size.id ? 'ring-4 ring-[#F1B428] shadow-lg shadow-[#F1B428]/30 scale-105' : 'hover:ring-2 hover:ring-[#F1B428]/50'
            }`}
          >
            <div className="aspect-[5/7] relative bg-[#1A1A1A]">
              <img
                src={size.image}
                alt={size.label}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <span className={`text-lg font-semibold ${
                data.buttSize === size.id ? 'text-[#F1B428]' : 'text-white'
              }`}>{size.label}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ButtSizeStep;
